var _IMapClass_map;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { MutableMap, objectIs, tp } from '../others';
import { ISet } from './iset';
// eslint-disable-next-line no-restricted-globals
const ArrayFrom = Array.from;
export const IMap = {
    new: (iterable) => new IMapClass(iterable),
    equal: (a, b) => {
        if (a.size !== b.size)
            return false;
        return a.every((v, k) => b.get(k) === v);
    },
};
class IMapClass {
    constructor(iterable) {
        _IMapClass_map.set(this, void 0);
        __classPrivateFieldSet(this, _IMapClass_map, new MutableMap(iterable), "f");
    }
    get size() {
        return __classPrivateFieldGet(this, _IMapClass_map, "f").size;
    }
    has(key) {
        return __classPrivateFieldGet(this, _IMapClass_map, "f").has(key);
    }
    get(key) {
        return __classPrivateFieldGet(this, _IMapClass_map, "f").get(key);
    }
    every(predicate) {
        for (const [k, v] of this.entries()) {
            if (!predicate(v, k))
                return false;
        }
        return true;
    }
    some(predicate) {
        for (const [k, v] of this.entries()) {
            if (predicate(v, k))
                return true;
        }
        return false;
    }
    delete(key) {
        if (!this.has(key))
            return this;
        return IMap.new(ArrayFrom(__classPrivateFieldGet(this, _IMapClass_map, "f")).filter(([k]) => !objectIs(k, key)));
    }
    set(key, value) {
        if (value === this.get(key))
            return this; // has no changes
        if (!this.has(key)) {
            return IMap.new([...__classPrivateFieldGet(this, _IMapClass_map, "f"), tp(key, value)]);
        }
        else {
            return IMap.new(ArrayFrom(__classPrivateFieldGet(this, _IMapClass_map, "f"), ([k, v]) => tp(k, objectIs(k, key) ? value : v)));
        }
    }
    update(key, updater) {
        if (!this.has(key))
            return this;
        const curr = this.get(key);
        return IMap.new(ArrayFrom(__classPrivateFieldGet(this, _IMapClass_map, "f"), ([k, v]) => 
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        tp(k, objectIs(k, key) ? updater(curr) : v)));
    }
    withMutations(actions) {
        const result = new MutableMap(__classPrivateFieldGet(this, _IMapClass_map, "f"));
        for (const action of actions) {
            switch (action.type) {
                case 'delete':
                    result.delete(action.key);
                    break;
                case 'set':
                    result.set(action.key, action.value);
                    break;
                case 'update': {
                    if (result.has(action.key)) {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        result.set(action.key, action.updater(result.get(action.key)));
                    }
                    break;
                }
            }
        }
        return IMap.new(result);
    }
    map(mapFn) {
        return IMap.new(this.toArray().map(([k, v]) => tp(k, mapFn(v, k))));
    }
    mapKeys(mapFn) {
        return IMap.new(this.toArray().map(([k, v]) => tp(mapFn(k), v)));
    }
    mapEntries(mapFn) {
        return IMap.new(this.toArray().map(mapFn));
    }
    forEach(callbackfn) {
        for (const [key, value] of __classPrivateFieldGet(this, _IMapClass_map, "f").entries()) {
            callbackfn(value, key);
        }
    }
    [(_IMapClass_map = new WeakMap(), Symbol.iterator)]() {
        return __classPrivateFieldGet(this, _IMapClass_map, "f")[Symbol.iterator]();
    }
    keys() {
        return __classPrivateFieldGet(this, _IMapClass_map, "f").keys();
    }
    values() {
        return __classPrivateFieldGet(this, _IMapClass_map, "f").values();
    }
    entries() {
        return __classPrivateFieldGet(this, _IMapClass_map, "f").entries();
    }
    toKeysArray() {
        return ArrayFrom(this.keys());
    }
    toValuesArray() {
        return ArrayFrom(this.values());
    }
    toEntriesArray() {
        return ArrayFrom(this.entries());
    }
    toArray() {
        return ArrayFrom(this.entries());
    }
    toSet() {
        return ISet.new(this.values());
    }
    toRawMap() {
        return __classPrivateFieldGet(this, _IMapClass_map, "f");
    }
}
